export const USER_ROLE_GUEST = 'guest'
export const USER_ROLE_CALL_CENTER = 'call_center'
export const USER_ROLE_LOGISTICIAN = 'logistician'
export const USER_ROLE_SUPER_LOGISTICIAN = 'super_logistician'
export const USER_ROLE_COLLECTOR = 'collector'
export const USER_ROLE_COLD_COOKER = 'cold_cooker'
export const USER_ROLE_COLD_CUTTER = 'cold_cutter'
export const USER_ROLE_HOT_COOKER = 'hot_cooker'
export const USER_ROLE_PIZZA_DOUGH = 'pizza_dough'
export const USER_ROLE_PIZZA_COOKER = 'pizza_cooker'
export const USER_ROLE_PIZZA_COLLECTOR = 'pizza_collector'
export const USER_ROLE_DELIVERY_COURIER = 'courier'
export const USER_ROLE_ADMIN = 'statistics'
// export const USER_ROLE_COURIERSTATS = 'courier_stats'
export const USER_ROLE_ACCOUNTING_WORKERS = 'accounting_workers'
export const USER_ROLE_WORKSHOPS_OVERALL = 'stats_workshop'



// WEBPACK FOOTER //
// ./src/constants/roles.js